<template>
  <div class="report-income">
    <SimpleLayout
      viewComponent="report-income-tab"
      :cardInfo="this.cardInfo"
      :leftAction="this.leftAction"
    />
  </div>
</template>

<script>
import Vue from "vue";
import SimpleLayout from "../../../layouts/SimpleLayout.vue";
import RoutesPaths from "../../../router/router-structure/routes-paths";

Vue.component("report-income-tab", () =>
  import("../components/visualization/ReportIncomeTab.vue")
);

export default {
  components: {
    SimpleLayout,
  },
  data: function() {
    return {
      leftAction: {
        text: "Financeiro",
        onClick: this.leftActionClickHandler,
      },
      cardInfo: {
        icon: "file-money.svg",
        title: "Informe de Rendimentos",
        description:
          "Acesse o seu informe para a declaração de imposto de renda.",
      },
    };
  },
  methods: {
    leftActionClickHandler() {
      this.$router.push({
        path: RoutesPaths.financial.rootName(),
        replace: true,
      });
    },
  },
};
</script>
<style lang="scss" >
.report-income .simple-layout--content {
  width: 85%;
}
</style>
